import { forwardRef, useContext } from "react";
import type { ComponentProps } from "react";
import { chakra } from "@chakra-ui/react";
import { IconContext } from "../IconContext";
const ContentCopyOutlinedIcon = forwardRef<SVGSVGElement, Omit<ComponentProps<typeof chakra["svg"]>, "minWidth" | "width" | "maxWidth" | "minHeight" | "height" | "maxHeight" | "__css"> & {
  size?: "xs" | "sm" | "md" | "lg";
}>(({
  size: sizeProp,
  ...rest
}, ref) => {
  const iconContext = useContext(IconContext);
  const size = sizeProp || iconContext.size;
  const width = {
    xs: "0.875rem",
    sm: 4,
    md: 5,
    lg: 6
  }[size];
  const props = {
    ...rest,
    minWidth: width,
    width,
    maxWidth: width,
    minHeight: width,
    height: width,
    maxHeight: width,
    fill: rest.fill || "currentColor"
  } as ComponentProps<typeof chakra["svg"]>;
  return <chakra.svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 -960 1080 1080" __css={{
    "& > *": {
      "transform": "translate(60px,60px)"
    }
  }} ref={ref} {...props}><path d="M326-192q-39.05 0-66.52-27.48Q232-246.95 232-286v-542q0-39.46 27.48-67.23Q286.95-923 326-923h422q39.46 0 67.23 27.77Q843-867.46 843-828v542q0 39.05-27.77 66.52Q787.46-192 748-192H326Zm0-94h422v-542H326v542ZM172-37q-39.46 0-67.23-27.77Q77-92.54 77-132v-636h95v636h516v95H172Zm154-249v-542 542Z" /></chakra.svg>;
});
export default ContentCopyOutlinedIcon;